export function capitalizeFirstLetter(text: string) {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function convertHtmlToText(htmlText: string) {
  return htmlText.replace(/<[^>]+>/g, ' ');
};
